import { PractitionerAssociationsMedicalService } from '../../models/Entities/PractitionerAssociations/MedicalServices/PractitionerAssociationMedicalService';
import { CommonState } from '../common/state/commonState';

export interface PractitionerMedicalServiceState
  extends CommonState<PractitionerAssociationsMedicalService> {}

export const PractitionerMedicalServiceUnloadState: any = {
  // loading all
  isLoadingAll: false,
  isLoadingAllSuccess: undefined,
  FailGettingAll: false,

  // loading one
  isLoadingOne: false,
  isLoadingOneSuccess: undefined,
  FailGettingOne: false,

  // saving
  isSaving: false,
  isSavingSuccess: undefined,
  FailSaving: false,

  // adding
  isAdding: false,
  isAddingSuccess: undefined,
  FailAdding: false,

  isFiltered: false,
  filterCriteria: undefined,

  list: [],
  Selected: undefined,
  Error: undefined
};
